import { render, staticRenderFns } from "./TemplateSchemaSettingsCollectionProperties.vue?vue&type=template&id=704031a6&"
import script from "./TemplateSchemaSettingsCollectionProperties.vue?vue&type=script&lang=js&"
export * from "./TemplateSchemaSettingsCollectionProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports